<template>
  <div :id="`fine-or-bonus-${data.fineOrBonusAmountCell.id}`" class="c-table-cell" :style="{ backgroundColor }">
    <div class="c-table__cell-value">
      <svg
        v-show="data.fineOrBonusAmountCell.isFined"
        width="10"
        height="12"
        viewBox="0 0 10 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M5 11V1M5 1L9 5M5 1L1 5"
          stroke="#FF238D"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>

      <span>{{ prettifyAmount(data.fineOrBonusAmountCell.amount) }}</span>
    </div>

    <b-popover
      v-if="data.fineOrBonusAmountCell.isFined"
      :target="`fine-or-bonus-${data.fineOrBonusAmountCell.id}`"
      triggers="hover blur"
      placement="bottom"
      container="#app"
      custom-class="fine-tooltip"
    >
      Выписан штраф за отсутствие объяснительной в размере 100 ฿
    </b-popover>
  </div>
</template>

<script>
import { prettifyAmount } from "@/helpers/workWithNumbers";
import { FINE_GROUP, BONUS_GROUP } from "@/constants/fineAndBonusGroups";

export default {
  name: "amount-cell",
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    backgroundColor() {
      if (this.data.fineOrBonusAmountCell.type.toString() === FINE_GROUP.toString()) {
        return "#FFD3E8";
      }
      if (this.data.fineOrBonusAmountCell.type.toString() === BONUS_GROUP.toString()) {
        return "#B8EFD5";
      }
      return "#FFF";
    },
  },
  methods: {
    prettifyAmount,
  },
};
</script>

<style lang="scss" scoped>
.c-table__cell-value {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;

  & span {
    margin-left: auto;
  }
}
.fine-tooltip {
  max-width: 250px;
}
</style>
